// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"493":"dcf2460c","738":"dcf2460c"}[chunkId] + ".chunk.css";
};